import { FilterField, FilterInputType } from 'layout/TableLayout/types.d';
import VALIDATION from 'utils/validation';

const EMPLOYEE_LIST_FILTERS: FilterField[] = [
  {
    type: FilterInputType.TEXT,
    name: 'userFullName',
    title: 'ФИО',
    rules: VALIDATION.userName,
  },
  {
    type: FilterInputType.TEXT,
    name: 'email',
    title: 'Email',
    rules: VALIDATION.email,
  },
];

export default EMPLOYEE_LIST_FILTERS;
